import { PlaceSearchResult } from "@vahak/core/dist/custom-types/location-search";

export function getCityFromAddress(address?: string): string {
    if (!address?.trim()) {
        return "";
    }

    const parts = address
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);

    if (parts.length === 0) {
        return "";
    }

    if (parts.length === 1) {
        return parts[0];
    }

    // Indian formatted addresses usually end with: ..., City, State PIN
    return parts[parts.length - 2] || parts[0];
}

function getPlaceCityState(place?: PlaceSearchResult): { city: string; state: string } {
    if (!place) {
        return { city: "", state: "" };
    }

    if (place.city?.trim()) {
        return {
            city: place.city.trim(),
            state: place.state?.trim() || ""
        };
    }

    const [city = "", state = ""] = (place.description || "")
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);

    return { city, state };
}

/** Short city label for route chips and summaries. */
export function getPlaceCityLabel(place?: PlaceSearchResult): string {
    if (!place) {
        return "";
    }

    if (place.city?.trim()) {
        return place.city.trim();
    }

    if (place.description?.trim()) {
        const cityFromDescription = getCityFromAddress(place.description);
        if (cityFromDescription) {
            return cityFromDescription;
        }
    }

    return place.locality?.trim() || place.sub_locality?.trim() || "";
}

/** State label from a place search result (city/state fields or parsed description). */
export function getPlaceStateLabel(place?: PlaceSearchResult): string {
    return getPlaceCityState(place).state;
}

/** Full description for location search dropdown rows. */
export function getPlaceDescriptionLabel(place?: PlaceSearchResult): string {
    if (!place) {
        return "";
    }

    if (place.description?.trim()) {
        return place.description.trim();
    }

    const { city, state } = getPlaceCityState(place);
    if (city && state) {
        return `${city}, ${state}`;
    }

    return city || state;
}
